import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import GridPlaceholder from './GridPlaceholder';

import createNewArrow from './create-new-arrow.png';

const NoItemsTr = styled.tr`
  td {
    vertical-align: middle;
    padding: 10px 0;
    border: none;
    border-bottom: 1px solid #f0f2f6;
  }
  &:hover {
    td {
      background: none !important;

      img {
        transform: none !important;
      }
    }
  }

  &:nth-child(1) {
    td {
      border: none !important;
    }
  }
  &:nth-child(3) {
    opacity: 0.7;
  }
  &:nth-child(4) {
    opacity: 0.6;
  }
  &:nth-child(5) {
    opacity: 0.5;
  }
  &:nth-child(6) {
    opacity: 0.4;
  }
`;

const NoItemsTd = styled.td`
  position: absolute;
  left: 0;
  width: auto;
  background-color: none !important;
`;

const NoItemsWrapper = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  min-height: 350px;
  width: 100%;
  z-index: 1;
  left: 0;
`;

const NoItemsTitle = styled.div`
  position: relative;
  font-size: 32px;
  font-weight: bold;
  color: #333;
  z-index: 1;
`;

const NoItemsSubtitle = styled.div`
  font-size: 24px;
  color: #767676;
  z-index: 1;
`;

const CreateNewArrow = styled.img`
  position: absolute;
  width: 415px;
  top: 0;
  right: 90px;
  background: none;
  z-index: 0;
`;

const NoItems = ({ title, subTitle, type, showArrow, isLoading }) => {
  if (isLoading) return <GridPlaceholder type={type} isLoading={isLoading} />;

  return (
    <>
      <NoItemsTr>
        <NoItemsTd colSpan="5">
          <NoItemsWrapper>
            <NoItemsTitle>{title}</NoItemsTitle>
            <NoItemsSubtitle>{subTitle}</NoItemsSubtitle>
            {showArrow && (
              <CreateNewArrow src={createNewArrow} alt="Create New Arrow" />
            )}
          </NoItemsWrapper>
        </NoItemsTd>
      </NoItemsTr>
      <GridPlaceholder type={type} />
    </>
  );
};

const ContentType = {
  Event: 'event',
  UpcomingEvent: 'upcoming_event',
  Files: 'files',
  User: 'user',
  Crew: 'crew'
};

NoItems.defaultProps = {
  title: "You don't have any... anything",
  subTitle: '',
  showArrow: false,
  type: ContentType.Event
};

NoItems.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  showArrow: PropTypes.bool,
  type: PropTypes.oneOf(['event', 'upcoming_event', 'files', 'user', 'crew'])
};

export { ContentType };
export default NoItems;
